module.exports = __webpack_public_path__ + "img/demo.1add5da2.jpg";